import { render, staticRenderFns } from "./InquiryQuestionnaireForm.vue?vue&type=template&id=39c1c6f0&scoped=true&"
import script from "./InquiryQuestionnaireForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryQuestionnaireForm.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryQuestionnaireForm.vue?vue&type=style&index=0&id=39c1c6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1c6f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VForm,VImg,VRow})
